var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKıdsgırldaıre(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "katman 2",
    viewBox: "0 0 10.92 10.92",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "katman 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.92,5.46c0,3.02-2.44,5.46-5.46,5.46S0,8.47,0,5.46,2.44,0,5.46,0s5.46,2.44,5.46,5.46",
    strokeWidth: "0px"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKıdsgırldaıre);
export default __webpack_public_path__ + "static/media/KIDSGIRLDAIRE.f255226df79c4ea94d6859a635a296cb.svg";
export { ForwardRef as ReactComponent };